module.exports = __webpack_public_path__ + "static/media/photo1.c668a986.png";